export interface PrimedCapture {
  audio: MediaStreamTrack[];
  video: MediaStreamTrack[];
}

export const NO_CAPTURE: PrimedCapture = { audio: [], video: [] };

export const stopTracks = (tracks: MediaStreamTrack[]) => {
  tracks.forEach((track) => track.stop());
};
